import React, { useState } from 'react';
import MarkdownEditor from './ui/markdownEditor';
export const Sandbox = ({
  onClose
}: {
  onClose: () => void;
}) => {
  const [formData, setFormData] = useState({
    id: 'sandbox',
    slideDescription: ''
  });
  const handleMarkdownChange = (newMarkdown: string) => {
    console.log('Markdown changing to:', newMarkdown);
    setFormData({
      ...formData,
      slideDescription: newMarkdown
    });
  };
  return <div className="flex flex-col mt-1" data-sentry-component="Sandbox" data-sentry-source-file="sandbox.tsx">
      <div className="flex flex-row w-full">
        <h3 className="flex flex-row font-bold mb-2">Sandbox</h3>
        <button onClick={onClose} className="m-2 p-2 bg-gray-800 rounded-md">Go Back To Chat View</button>
      </div>
      <div className="flex flex-col items-center text-center mt-10">
          This is the sandbox page.
      </div>
      <MarkdownEditor key={formData.id} markdown={formData.slideDescription || ''} onChange={newMarkdown => {
      console.log('MarkdownEditor onChange:', newMarkdown);
      handleMarkdownChange(newMarkdown);
    }} data-sentry-element="MarkdownEditor" data-sentry-source-file="sandbox.tsx" />
    </div>;
};